export class NotSignedInError extends Error {
  code?: string = 'account/not-signed-in';
}
